import { render, staticRenderFns } from "./detailDarmawangsa.vue?vue&type=template&id=d9fc14ec&scoped=true&"
import script from "./detailDarmawangsa.vue?vue&type=script&lang=js&"
export * from "./detailDarmawangsa.vue?vue&type=script&lang=js&"
import style0 from "./detailDarmawangsa.vue?vue&type=style&index=0&id=d9fc14ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fc14ec",
  null
  
)

export default component.exports